<section class="locked" *ngIf="loading">
  <mat-spinner [strokeWidth]="5"></mat-spinner>
</section>